import { createTaskwayApiClients, getTaskwayApiErrorMessage } from '@taskway/shared';
import { webConfig } from '../config/config';

const baseURL = webConfig.apiBaseUrl;

// Handler to be set by App for 401
let onUnauthorized: (() => void) | undefined;

export const setOnUnauthorized = (cb: () => void) => {
  onUnauthorized = cb;
};

const webClients = createTaskwayApiClients({
  apiBaseUrl: baseURL,
  authApiBaseUrl: baseURL,
  timeoutMs: 10000,
  onUnauthorized: () => {
    if (onUnauthorized) onUnauthorized();
  },
});

export const webApi = webClients.api;
export const webAuthApi = webClients.authApi;

export const setWebAuthToken = (token: string | null) => {
  webClients.setAuthToken(token);
};

export const getWebApiErrorMessage = (error: any, fallback: string) => {
  return getTaskwayApiErrorMessage(error, fallback, 'Server is not running. Please contact administrator.');
};
